export const iconFontAwesomeWritingSquarePen = (
	<i className="fa-solid fa-square-pen"></i>
);
